<form action="" [formGroup]="proveedorRulesForm" #proveedorRulesFormRef (ngSubmit)="onSubmit()">
    <div class="mb-2">
        <div *ngIf="relatedProveedor" class="text-center">
            <div class="row">
                <div class="col-12">
                    <div class="row">
                        <div class="col-2">Rut: {{relatedProveedor.rut}}-{{relatedProveedor.dv}}</div>
                        <div class="col-8">Nombre: {{relatedProveedor.razonSocial}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-body">

        <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-pills nav-fill">
            <li [ngbNavItem]="1">
                <a ngbNavLink>Referencias</a>
                <ng-template ngbNavContent>
                    <div class="card my-5">
                        <div class="row">
                            <div class="col-9 offset-md-2">
                                <p class="mx-auto mt-4">
                                    Seleccione entre los distintos tipos de documento que serán exigidos en las
                                    referencias de los documentos recibidos en su casilla de intercambio. Los documentos
                                    recibidos que no presenten el o los tipos de documento seleccionados en sus
                                    referencias, serán rechazados automáticamente.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="form-group position-relative mx-auto">
                        <div class="row">
                            <label for="" class="col-3 label-control">Codigos de documento en Referencias</label>
                            <div class="col-9">
                                <!-- <input type="number" name="requiredReferenceCodes" id="requiredReferenceCodes" formControlName="requiredReferenceCodes" class="form-control"> -->
                                <ng-select [items]="referenceCodesSource" [multiple]="true"
                                    placeholder="Ingresar codigos del tipo de dte para referencias"
                                    formControlName="requiredReferenceCodes" bindLabel="descripcion" [addTag]="addTagFn"
                                    [hideSelected]="true" notFoundText="Codigo no encontrado">
                                    <ng-template ng-option-tmp let-item="item">
                                        {{item.descripcion}}<br>
                                        <small>{{item.codigo}}</small>
                                    </ng-template>
                                </ng-select>
                                <div *ngIf="proveedorRulesFormRef.submitted &&( proveedorRulesForm.get('requiredReferenceCodes').invalid ||  proveedorRulesForm.get('requiredReferenceCodes').dirty)"
                                    class="invalid-feedback">
                                    <div *ngIf="proveedorRulesForm.get('requiredReferenceCodes').errors?.required">Campo
                                        requerido</div>

                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </li>
            <li [ngbNavItem]="2">
                <a ngbNavLink>Etiquetas</a>
                <ng-template ngbNavContent>
                    <div class="card my-5">
                        <div class="row">
                            <div class="col-9 offset-md-2">
                                <p class="mx-auto mt-4">
                                    Seleccione entre las distintas etiquetas que conforman el archivo XML del documento
                                    y que serán exigidos en los documentos recibidos en su casilla de intercambio. Los
                                    documentos recibidos que no presenten la o las etiquetas seleccionadas en el archivo
                                    XML de dicho documento, serán rechazados automáticamente.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="form-group position-relative mx-auto">
                        <div class="row">
                            <div class="offset-sm-2 col-3">
                                <div class="row">
                                    <div class="col-10 label-control">
                                        Encabezado
                                    </div>
                                    <div class="col-1">
                                        <input type="checkbox" formControlName="encabezadoGroup" name="encabezadoGroup"
                                            (change)="getTagsByRange(proveedorRulesForm.controls.encabezadoGroup.value,1,149)">
                                    </div>
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="row">
                                    <div class="col-10">
                                        Detalles
                                    </div>
                                    <div class="col-1">
                                        <input type="checkbox" formControlName="detallesGroup" name="detallesGroup"
                                            (change)="getTagsByRange(proveedorRulesForm.controls.detallesGroup.value,150,191)">

                                    </div>
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="row">
                                    <div class="col-10">
                                        Subtotales Informativos
                                    </div>
                                    <div class="col-1">
                                        <input type="checkbox" formControlName="subtotalesInformativosGroup"
                                            name="subtotalesInformativosGroup"
                                            (change)="getTagsByRange(proveedorRulesForm.controls.subtotalesInformativosGroup.value,192,200)">

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="offset-sm-2 col-3">
                                <div class="row">
                                    <div class="col-10 label-control">
                                        Información Descuentos y recargos
                                    </div>
                                    <div class="col-1">
                                        <input type="checkbox" formControlName="informacionesDescuentosRecargosGroup"
                                            name="informacionesDescuentosRecargosGroup"
                                            (change)="getTagsByRange(proveedorRulesForm.controls.informacionesDescuentosRecargosGroup.value,201,207)">
                                    </div>
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="row">
                                    <div class="col-10">
                                        Información de Referencia
                                    </div>
                                    <div class="col-1">
                                        <input type="checkbox" formControlName="informacionReferenciaGroup"
                                            name="informacionReferenciaGroup"
                                            (change)="getTagsByRange(proveedorRulesForm.controls.informacionReferenciaGroup.value,208,216)">

                                    </div>
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="row">
                                    <div class="col-10">
                                        Comisiones y otros cargos
                                    </div>
                                    <div class="col-1">
                                        <input type="checkbox" formControlName="comisionesOtrosCargosGroup"
                                            name="comisionesOtrosCargosGroup"
                                            (change)="getTagsByRange(proveedorRulesForm.controls.comisionesOtrosCargosGroup.value,217,223)">

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-group position-relative mx-auto">
                        <div class="row">
                            <label for="" class="col-2 label-control">Etiquetas Requeridas</label>
                            <div class="col-10">
                                <!-- <input type="number" name="requiredDocumentTags" id="requiredDocumentTags" formControlName="requiredDocumentTags" class="form-control"> -->

                                <ng-select [items]="tagsProveedorSource" [multiple]="true"
                                    placeholder="Ingresar etiquetas" formControlName="requiredDocumentTags"
                                    bindLabel="nombre" [addTag]="addTagFn" [hideSelected]="true"
                                    notFoundText="Etiqueta no encontrada" addTagText="Agregar etiqueta">
                                    <ng-template ng-option-tmp let-item="item">
                                        {{item.nombre}}<br>
                                        <small>{{item.xmlTag}}</small>
                                    </ng-template>
                                </ng-select>
                                <div *ngIf="proveedorRulesFormRef.submitted &&( proveedorRulesForm.get('requiredDocumentTags').invalid ||  proveedorRulesForm.get('requiredDocumentTags').dirty)"
                                    class="invalid-feedback">
                                    <div *ngIf="proveedorRulesForm.get('requiredDocumentTags').errors?.required">Campo
                                        requerido</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </li>
        </ul>
        <div [ngbNavOutlet]="nav" class="mt-5"></div>



    </div>
    <div class="modal-footer">
        <button type="submit" id="add-contact-item" class="btn btn-success add-contact-item">
            <i class="la la-paper-plane-o d-lg-none"></i>
            <span class="d-none d-lg-block">Guardar</span>
        </button>

        <button type="button" class="btn btn-secondary ml-3" (click)="sendCloseRequest()">
            <span class="d-none d-lg-block">Cerrar</span>
        </button>
    </div>
</form>